import { useState, useEffect } from 'react'
import useTranslate from '../../../i18n/useTranslate'
import useLookupService from '../../lookup/useLookupService'

export type OptType = {
    label: string
    value: string
}

const useProjectStatus = () => {
    const translate = useTranslate()
    const callLookup = useLookupService()
    const [projectStatus, setProjectStatus] = useState<OptType[]>([])

    const getProjectStatusType = async () => {
        const { result } = await callLookup.callProjectSubmitTypeLut()
        // const filterAdd = res.result.filter((item) => {
        //     return item.isAdd
        // })
        const formatedData = result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === 'th' ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setProjectStatus(formatedData)
    }

    useEffect(() => {
        getProjectStatusType()
    }, [translate.languageStore.currentLanguage])

    return { projectStatus }
}

export default useProjectStatus
